import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.dimensionTables`;

export const INIT = `${SCOPE}/INIT`;

export const INIT_REQUESTS = `${SCOPE}/INIT_REQUESTS`;

export const START_FETCHING = `${SCOPE}/START_FETCHING`;

export const SET_DIMENSIONS = `${SCOPE}/SET_DIMENSIONS`;

export const SET_DIMENSION = `${SCOPE}/SET_DIMENSION`;
export const SWITCH_DIMENSION = `${SCOPE}/SWITCH_DIMENSION`;
export const REFRESH_DIMENSION = `${SCOPE}/REFRESH_DIMENSION`;

export const SET_UNIT = `${SCOPE}/SET_UNIT`;

export const SET_DIMENSION_TABLES_STATE = `${SCOPE}/SET_DIMENSION_TABLES_STATE`;
